import React from "react";
import InternetCustomerList from "../InternetCustomersList";

// DVPL uses the exact same OneRADIUS API and list UI as Pioneer —
// previously this file was a full copy of InternetCustomersList with
// only the default `type` changed, so every fix had to be made twice.
// Now it simply reuses that component.
const DVPLCustomersList = () => <InternetCustomerList type="dvpl" />;

export default DVPLCustomersList;
